// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__FEETX","turn":"Loading_turn__tmVBQ"};